module.exports = __webpack_public_path__ + "static/img/gongan.ca1f974.png";